export default class ChatTicketModel {
  id: number | null;
  user_id: string | null;
  message: string | null;
  message_type: string | null;
  is_read: string | null;
  is_mine: boolean;
  deleted_at: string | null;
  created_at: string | null;
  updated_at: string | null;
  ticket_id: string | null;
  constructor() {
    this.id = 0;
    this.user_id = null;
    this.message = null;
    this.message_type = null;
    this.is_read = null;
    this.is_mine = false;
    this.deleted_at = null;
    this.created_at = null;
    this.updated_at = null;
    this.ticket_id = null;
  }
}
